import { Box, Input, InputAdornment, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactSelect from 'components/common/react-select/ReactSelect';
import { getAppBuilderCurrentStyleValue } from 'app/app/editor/tabs/settings/style-editor/StylesEditorContainer';

interface SizeFieldProps {
    formState: any;
    propertyName: string;
    onChangeStyle: (value: any) => void;
    uid: string;
}

const sizeTypeOptionsList = [
    {
        label: 'Fill',
        value: 'fill',
    },
    {
        label: 'Relative',
        value: 'relative',
    },
    {
        label: 'Fixed',
        value: 'fixed',
    },
    {
        label: 'Fit Content',
        value: 'auto',
    },
];
export default function SizeField({ propertyName, formState, onChangeStyle = () => {}, uid }: SizeFieldProps) {
    const [currentSizeType, setCurrentSizeType] = useState<string>('fill');
    const sizeTypePropertyName = 'size-type-' + propertyName;

    useEffect(() => {
        const sizeType = getAppBuilderCurrentStyleValue(formState, sizeTypePropertyName);
        setCurrentSizeType(sizeType);
    }, [getAppBuilderCurrentStyleValue(formState, sizeTypePropertyName)]);

    const handleChangeSizeType = (value: any) => {
        setCurrentSizeType(value);
        let sizeValue = '';
        const element = document.querySelector('[data-uid="' + uid + '"]');

        switch (value) {
            case 'fill':
                break;
            case 'fixed':
                if (element) {
                    sizeValue =
                        Math.floor(element.getBoundingClientRect()[propertyName == 'height' ? 'height' : 'width']) +
                        'px';
                }
                break;
            case 'relative':
                if (element && element.parentElement) {
                    sizeValue =
                        Math.floor(
                            (element.getBoundingClientRect()[propertyName == 'height' ? 'height' : 'width'] /
                                element.parentElement.getBoundingClientRect()[
                                    propertyName == 'height' ? 'height' : 'width'
                                ]) *
                                100,
                        ) + '%';
                }
                break;
            case 'auto':
                sizeValue = 'fit-content';
                break;
        }
        onChangeStyle({
            [sizeTypePropertyName]: value,
            [propertyName]: sizeValue,
        });
    };

    const getValue = () => {
        if (currentSizeType == 'fill') return 1;
        if (currentSizeType == 'auto') return 'auto';
        return getAppBuilderCurrentStyleValue(formState, propertyName).replace('px', '').replace('%', '');
    };

    const changeSizeVal = (e: any) => {
        if (currentSizeType == 'fixed') onChangeStyle({ [propertyName]: e.target.value + 'px' });
        if (currentSizeType == 'relative') onChangeStyle({ [propertyName]: e.target.value + '%' });
    };
    return (
        <Stack direction={'row'} spacing={1}>
            <Box sx={{ flexGrow: 1 }}>
                <Input
                    fullWidth
                    value={getValue()}
                    onChange={changeSizeVal}
                    readOnly={currentSizeType == 'fill' || currentSizeType == 'auto'}
                    inputProps={{ 'data-1p-ignore': true }}
                    className={'design-variant--secondary'}
                    disabled={currentSizeType == 'fill' || currentSizeType == 'auto'}
                    endAdornment={
                        currentSizeType != 'auto' ? (
                            <InputAdornment position="end" sx={{ mx: 0 }}>
                                <Box sx={{ px: 1 }}>
                                    {currentSizeType == 'fill' && 'fr'}
                                    {currentSizeType == 'relative' && '%'}
                                    {currentSizeType == 'fixed' && 'px'}
                                </Box>
                            </InputAdornment>
                        ) : undefined
                    }
                />
            </Box>

            <Box sx={{ minWidth: '125px', width: '40%', flexShrink: 0 }}>
                <ReactSelect
                    data={sizeTypeOptionsList}
                    value={[currentSizeType]}
                    update={handleChangeSizeType}
                    className={'design-variant--secondary'}
                />
            </Box>
        </Stack>
    );
}
